module.exports = __webpack_public_path__ + "static/media/Lock.1b3f94dc.svg";